module.exports = __webpack_public_path__ + "static/media/public.08f44307.asc";